(ns medplast.data)

(def product-types
  [
   "1 dalies rinktuvas"
   "Plokštelė"
   "Rinktuvo maišelis"
   "Šlapimo surinkimo maišas"
   "Priedai"
   "Kiti"
   ])
